import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Row, Col, Card, Form, Button, Alert, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import api from "../../../axiosConfig";
import PartPickerModal from "../../pickers/PartPickerModal";
import ClientPickerModal from "../../pickers/ClientPickerModal";

import EquipmentTariffs from "../EquipmentTariffs";
import EquipmentSituation from "../EquipmentSituation";
import InterventionsSummary from "./InterventionsSummary";

export default function EchipamentForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;

  // Form Fields
  const [bxseria, setBxseria] = useState("");
  const [bxcodech, setBxcodech] = useState("");
  const [bxdescrechip, setBxdescrechip] = useState("");
  
  const [partId, setPartId] = useState(null);
  const [partLabel, setPartLabel] = useState("Alege reper...");

  const [customerId, setCustomerId] = useState(null);
  const [customerLabel, setCustomerLabel] = useState("Alege utilizator...");

  const [customerId1, setCustomerId1] = useState(null);
  const [customerLabel1, setCustomerLabel1] = useState("Alege proprietar...");

  const [grupaId, setGrupaId] = useState("");
  const [tipContractId, setTipContractId] = useState("");
  const [tipContorId, setTipContorId] = useState("");
  const [bxlocatie, setBxlocatie] = useState("");
  const [bxeticheta, setBxeticheta] = useState("");
  const [bxtelefon, setBxtelefon] = useState("");
  const [angIngId, setAngIngId] = useState("");
  const [branchId, setBranchId] = useState("1");
  const [dataCitire, setDataCitire] = useState("");
  const [chirie, setChirie] = useState("0.0");
  const [tarif, setTarif] = useState("0.0");

  // Nomenclator lists
  const [grupe, setGrupe] = useState([]);
  const [tipuriContract, setTipuriContract] = useState([]);
  const [tipuriContor, setTipuriContor] = useState([]);
  const [users, setUsers] = useState([]);
  const [branches, setBranches] = useState([]);

  // UI state
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});

  // Pickers state
  const [partPickerOpen, setPartPickerOpen] = useState(false);
  const [clientPickerOpen, setClientPickerOpen] = useState(false);
  const [clientPickerTarget, setClientPickerTarget] = useState(null); // 'utilizator' | 'proprietar'

  useEffect(() => {
    loadNomenclators();
    if (isEdit) {
      loadEchipament();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const loadNomenclators = async () => {
    try {
      const [rGrupe, rContracts, rContoare, rUsers, rBranches] = await Promise.all([
        api.get("/contor/grupe", { params: { limit: 100 } }),
        api.get("/contor/nomenclatoare/tipuri-contract"),
        api.get("/contor/nomenclatoare/tipuri-contor"),
        api.get("/contor/nomenclatoare/utilizatori", { params: { limit: 100 } }),
        api.get("/branches/", { params: { limit: 200 } }),
      ]);

      setGrupe(rGrupe.data?.items || []);
      setTipuriContract(rContracts.data || []);
      setTipuriContor(rContoare.data || []);
      setUsers(rUsers.data?.items || []);
      setBranches(rBranches.data?.items || []);
    } catch (e) {
      console.error("Eroare la încărcarea nomenclatoarelor:", e);
    }
  };

  const loadEchipament = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await api.get(`/contor/echipamente/${id}`);
      const data = res.data;

      setBxseria(data.bxseria);
      setBxcodech(data.bxcodech || "");
      setBxdescrechip(data.bxdescrechip || "");
      setPartId(data.bxpart_id);
      setPartLabel(data.part_name ? `${data.part_code} • ${data.part_name}` : "Alege reper...");
      setCustomerId(data.bxcustomer_id);
      setCustomerLabel(data.utilizator_name || "Fără client utilizator");
      setCustomerId1(data.bxcustomer_id1);
      setCustomerLabel1(data.proprietar_name || "Alege proprietar...");
      setGrupaId(data.bxgrupaechip_id || "");
      setTipContractId(data.bxtipcontrech_id || "");
      setTipContorId(data.bxtipcontor_id || "");
      setBxlocatie(data.bxlocatie || "");
      setBxeticheta(data.bxeticheta || "");
      setBxtelefon(data.bxtelefon || "");
      setAngIngId(data.bxang_ing_id || "");
      setBranchId(String(data.branch_id || "1"));
      setChirie(String(data.chirie ?? "0.0"));
      setTarif(String(data.tarif ?? "0.0"));

      if (data.data_citire) {
        // Cut the time zone info for input datetime-local
        setDataCitire(data.data_citire.substring(0, 16));
      }
    } catch (e) {
      setError(e.response?.data?.detail || e.message || "Eroare la încărcarea echipamentului.");
    } finally {
      setLoading(false);
    }
  };

  const validate = () => {
    const errs = {};
    if (!bxseria.trim()) errs.bxseria = "Seria este obligatorie.";
    if (!partId) errs.part = "Modelul (reperul) este obligatoriu.";

    if (!customerId1) errs.customer1 = "Clientul proprietar este obligatoriu.";
    if (!branchId) errs.branch = "Branch-ul este obligatoriu.";
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handlePickPart = (part) => {
    setPartId(part.id);
    setPartLabel(part.label);
    if (errors.part) setErrors({ ...errors, part: null });
  };

  const handlePickClient = (client) => {
    if (clientPickerTarget === "utilizator") {
      setCustomerId(client.id);
      setCustomerLabel(client.label);
      if (errors.customer) setErrors({ ...errors, customer: null });
    } else {
      setCustomerId1(client.id);
      setCustomerLabel1(client.label);
      if (errors.customer1) setErrors({ ...errors, customer1: null });
    }
  };

  const copyCustomerToProprietar = () => {
    if (customerId) {
      setCustomerId1(customerId);
      setCustomerLabel1(customerLabel);
      if (errors.customer1) setErrors({ ...errors, customer1: null });
    } else {
      toast.warning("Selectați mai întâi clientul utilizator.");
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setSaving(true);
    setError("");

    const payload = {
      bxseria: bxseria.trim(),
      bxcodech: bxcodech.trim() || null,
      bxdescrechip: bxdescrechip.trim() || null,
      bxpart_id: Number(partId),
      bxcustomer_id: customerId ? Number(customerId) : null,
      bxcustomer_id1: Number(customerId1),
      bxgrupaechip_id: grupaId ? Number(grupaId) : null,
      bxtipcontrech_id: tipContractId ? Number(tipContractId) : null,
      bxtipcontor_id: tipContorId ? Number(tipContorId) : null,
      bxlocatie: bxlocatie.trim() || null,
      bxeticheta: bxeticheta.trim() || null,
      bxtelefon: bxtelefon.trim() || null,
      bxang_ing_id: angIngId ? Number(angIngId) : null,
      branch_id: Number(branchId),
      data_citire: dataCitire || null,
      chirie: parseFloat(chirie) || 0.0,
      tarif: parseFloat(tarif) || 0.0,
    };

    try {
      if (isEdit) {
        await api.put(`/contor/echipamente/${id}`, payload);
        toast.success("Echipamentul a fost actualizat cu succes.");
      } else {
        await api.post("/contor/echipamente", payload);
        toast.success("Echipamentul a fost înregistrat cu succes.");
      }
      navigate("/contor/echipamente");
    } catch (e) {
      setError(e.response?.data?.detail || e.message || "Eroare la salvare.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" />
        <p className="mt-3">Se încarcă datele echipamentului...</p>
      </Container>
    );
  }

  return (
    <Container fluid className="py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="mb-1 text-dark fw-bold">
            {isEdit ? `Editează Echipament: ${bxseria}` : "Adaugă Echipament"}
          </h2>
          <p className="text-muted mb-0">
            {isEdit ? "Modifică detaliile tehnice sau asocierile echipamentului" : "Înregistrează un echipament nou în nomenclator"}
          </p>
        </div>
        <Button variant="outline-secondary" onClick={() => navigate("/contor/echipamente")}>
          Înapoi la Listă
        </Button>
      </div>

      {error && <Alert variant="danger">{error}</Alert>}

      {isEdit && <EquipmentSituation id={id} onChanged={loadEchipament} />}
      {isEdit && <InterventionsSummary id={id} />}
      <Form onSubmit={handleSave}>
        <Row className="g-4">
          {/* Coloana Stângă: Date Principale */}
          <Col xs={12} lg={8}>
            <Card className="shadow-sm border-0 mb-4">
              <Card.Header className="bg-light fw-bold py-3 text-dark">Date Identificare & Tehnice</Card.Header>
              <Card.Body className="p-4">
                <Row className="g-3">
                  <Col xs={12} md={6}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Număr Serie (S/N) <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        value={bxseria}
                        onChange={(e) => {
                          setBxseria(e.target.value);
                          if (errors.bxseria) setErrors({ ...errors, bxseria: null });
                        }}
                        isInvalid={!!errors.bxseria}
                        placeholder="Introduceți seria unică..."
                      />
                      <Form.Control.Feedback type="invalid">{errors.bxseria}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col xs={12} md={6}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Cod Echipament (Intern/Inventar)</Form.Label>
                      <Form.Control
                        value={bxcodech}
                        onChange={(e) => setBxcodech(e.target.value)}
                        placeholder="ex: PRN-001"
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={12}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Denumire/Descriere Echipament</Form.Label>
                      <Form.Control
                        value={bxdescrechip}
                        onChange={(e) => setBxdescrechip(e.target.value)}
                        placeholder="ex: HP LaserJet Enterprise M506"
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={12}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Model Echipament (Produs din Catalog) <span className="text-danger">*</span>
                      </Form.Label>
                      <div className="d-flex gap-2">
                        <Form.Control
                          value={partLabel}
                          readOnly
                          isInvalid={!!errors.part}
                          className="bg-light"
                        />
                        <Button
                          variant="outline-dark"
                          onClick={() => setPartPickerOpen(true)}
                        >
                          Alege
                        </Button>
                      </div>
                      {errors.part && <div className="text-danger small mt-1">{errors.part}</div>}
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            <Card className="shadow-sm border-0 mb-4">
              <Card.Header className="bg-light fw-bold py-3 text-dark">Asociere Clienți</Card.Header>
              <Card.Body className="p-4">
                <Row className="g-3">
                  <Col xs={12}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Client utilizator (poate lipsi când echipamentul este în firmă)
                      </Form.Label>
                      <div className="d-flex gap-2">
                        <Form.Control
                          value={customerLabel}
                          readOnly
                          isInvalid={!!errors.customer}
                          className="bg-light"
                        />
                        <Button
                          variant="outline-dark"
                          onClick={() => {
                            setClientPickerTarget("utilizator");
                            setClientPickerOpen(true);
                          }}
                        >
                          Alege
                        </Button>
                      </div>
                      {errors.customer && <div className="text-danger small mt-1">{errors.customer}</div>}
                    </Form.Group>
                  </Col>

                  <Col xs={12}>
                    <Form.Group>
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <Form.Label className="fw-semibold mb-0">
                          Proprietarul echipamentului <span className="text-danger">*</span>
                        </Form.Label>
                        <Button
                          variant="link"
                          className="p-0 text-decoration-none small text-primary"
                          onClick={copyCustomerToProprietar}
                        >
                          Copiază de la Utilizator
                        </Button>
                      </div>
                      <div className="d-flex gap-2">
                        <Form.Control
                          value={customerLabel1}
                          readOnly
                          isInvalid={!!errors.customer1}
                          className="bg-light"
                        />
                        <Button
                          variant="outline-dark"
                          onClick={() => {
                            setClientPickerTarget("proprietar");
                            setClientPickerOpen(true);
                          }}
                        >
                          Alege
                        </Button>
                      </div>
                      <Form.Text className="text-muted">Proprietarul poate fi diferit de clientul utilizator. Factura se emite clientului din contractul valabil pentru perioada facturată.</Form.Text>
                      {errors.customer1 && <div className="text-danger small mt-1">{errors.customer1}</div>}
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          {/* Coloana Dreaptă: Detalii Contract, Gestiune, Locație */}
          <Col xs={12} lg={4}>
            <Card className="shadow-sm border-0 mb-4">
              <Card.Header className="bg-light fw-bold py-3 text-dark">Localizare & Repartizare</Card.Header>
              <Card.Body className="p-4">
                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold">Locație exactă (etaj, birou etc.)</Form.Label>
                  <Form.Control
                    value={bxlocatie}
                    onChange={(e) => setBxlocatie(e.target.value)}
                    placeholder="ex: Etaj 2, Dep. IT"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold">Etichetă/Cod QR inventar</Form.Label>
                  <Form.Control
                    value={bxeticheta}
                    onChange={(e) => setBxeticheta(e.target.value)}
                    placeholder="ex: QR-100234"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold">Telefon Contact Locație</Form.Label>
                  <Form.Control
                    value={bxtelefon}
                    onChange={(e) => setBxtelefon(e.target.value)}
                    placeholder="ex: 0722xxxxxx"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold">Inginer/Tehnician Repartizat</Form.Label>
                  <Form.Select
                    value={angIngId}
                    onChange={(e) => setAngIngId(e.target.value)}
                  >
                    <option value="">— Nesortat/Fără inginer principal —</option>
                    {users.map((u) => (
                      <option key={u.id} value={u.id}>
                        {u.username}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold">
                    Filială/Branch <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    value={branchId}
                    onChange={(e) => {
                      setBranchId(e.target.value);
                      if (errors.branch) setErrors({ ...errors, branch: null });
                    }}
                    isInvalid={!!errors.branch}
                  >
                    {branches.map((b) => (
                      <option key={b.id} value={b.id}>
                        {b.name} ({b.code})
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">{errors.branch}</Form.Control.Feedback>
                </Form.Group>
              </Card.Body>
            </Card>

            <Card className="shadow-sm border-0 mb-4">
              <Card.Header className="bg-light fw-bold py-3 text-dark">Contract & Contoare</Card.Header>
              <Card.Body className="p-4">
                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold">Grupă Echipamente</Form.Label>
                  <Form.Select
                    value={grupaId}
                    onChange={(e) => setGrupaId(e.target.value)}
                  >
                    <option value="">— Fără grupă —</option>
                    {grupe.map((g) => (
                      <option key={g.bxid} value={g.bxid}>
                        {g.bxdescr} ({g.bxcod})
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold">Tip Contract</Form.Label>
                  <Form.Select
                    value={tipContractId}
                    onChange={(e) => setTipContractId(e.target.value)}
                  >
                    <option value="">— Fără contract activ —</option>
                    {tipuriContract.map((c) => (
                      <option key={c.bxid} value={c.bxid}>
                        {c.bxdescr} ({c.bxcod})
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold">Tip Contor principal</Form.Label>
                  <Form.Select
                    value={tipContorId}
                    onChange={(e) => setTipContorId(e.target.value)}
                  >
                    <option value="">— Fără contor —</option>
                    {tipuriContor.map((ct) => (
                      <option key={ct.bxid} value={ct.bxid}>
                        {ct.bxdescr} ({ct.bxcod})
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold">Ultima citire la data</Form.Label>
                  <Form.Control
                    type="datetime-local"
                    value={dataCitire}
                    onChange={(e) => setDataCitire(e.target.value)}
                  />
                </Form.Group>

                <Row className="g-2">
                  <Col xs={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold">Chirie lunară</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.01"
                        value={chirie}
                        onChange={(e) => setChirie(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold">Abonament / asistență lunară (lei)</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.0001"
                        value={tarif}
                        onChange={(e) => setTarif(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <div className="d-flex justify-content-end gap-2 mb-5">
          <Button
            variant="outline-secondary"
            onClick={() => navigate("/contor/echipamente")}
            disabled={saving}
          >
            Renunță
          </Button>
          <Button variant="dark" type="submit" disabled={saving}>
            {saving ? "Se salvează..." : "Salvează Echipamentul"}
          </Button>
        </div>
      </Form>

      {isEdit && <EquipmentTariffs key={id} id={id}/>}
      <PartPickerModal
        show={partPickerOpen}
        onHide={() => setPartPickerOpen(false)}
        onPick={handlePickPart}
        title="Alege Model Echipament"
      />

      <ClientPickerModal
        show={clientPickerOpen}
        onHide={() => setClientPickerOpen(false)}
        onPick={handlePickClient}
        title={clientPickerTarget === "utilizator" ? "Alege Utilizator" : "Alege proprietarul echipamentului"}
      />
    </Container>
  );
}
